import { endpoints } from '../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const productServices = {
	getProducts,
	getCategories,
	createProductGroup,
	getProductGroupList,
	editProductGroup,
	getProductGroupById,
	getProductSchedule,
};

function getProducts(req = {}) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.GET_PRODUCTS, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	return fetch(url, requestOptions).then(handleResponse);
}

function getCategories(req = {}) {
	const params = {
		...req,
	};

	const url = toQueryStringURL(endpoints.GET_CATEGORIES, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};

	return fetch(url, requestOptions).then(handleResponse);
}

function createProductGroup(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.PRODUCT_GROUP_CREATE, requestOptions).then(handleResponse);
}

function getProductGroupList(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.PRODUCT_GROUP_LIST, requestOptions).then(handleResponse);
}
function editProductGroup(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.PRODUCT_GROUP_EDIT, requestOptions).then(handleResponse);
}
function getProductGroupById(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.PRODUCT_GROUP_FETCH_BY_ID, requestOptions).then(handleResponse);
}

function getProductSchedule(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};

	return fetch(endpoints.PRODUCT_GROUP_SCHEDULE, requestOptions).then(handleResponse);
}

export default productServices;
